const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "File Name",
    dataIndex: "file_name",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "File Number",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "Invoice No.",
    dataIndex: "invoice_number",
    render: defaultRender,
  },
  {
    title: "Generated By",
    dataIndex: "generated_name",
    render: defaultRender,
  },
  {
    title: "Amount",
    dataIndex: "total_amount",
    render: (value) => {
    const num = Number(value);
    return <span>${!isNaN(num) ? num.toFixed(2) : "0.00"}</span>;
    },
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Invoice Send Date",
    dataIndex: "sended_at",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => (
      <p
        className={`font-bold uppercase ${
          value === "paid" ? "text-green-500" : "text-red-500"
        }`}
      >
        {value}
      </p>
    ),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

export default columns;
